// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerFooter_container__aIkSr","content":"ContainerFooter_content__AH9PI"};